(function () {
  var hiddenClass = 'community-page-tabs-panel--hidden';
  var panelClass = 'community-page-tabs-panel';
  var enterClass = 'community-page-tabs-panel--enter';
  var initializedRoots = new WeakSet();

  function decodeSettingValue(value) {
    var trimmedValue = (value || '').trim();

    if (!trimmedValue) return '';

    try {
      var parsedValue = JSON.parse(trimmedValue);

      if (typeof parsedValue === 'string') {
        return parsedValue;
      }
    } catch (error) {
      return trimmedValue;
    }

    return trimmedValue;
  }

  function splitTargets(value) {
    return decodeSettingValue(value)
      .split(/[\n,;，；]+/)
      .map(function (target) {
        return target.trim();
      })
      .filter(Boolean);
  }

  function normalizeToken(value) {
    return (value || '').trim().replace(/\s+/g, ' ').toLowerCase();
  }

  function parseSectionNameMap(value) {
    var sectionNameMap = {};
    var rows = decodeSettingValue(value).split(/[\n]+/);

    rows.forEach(function (row) {
      var cleanRow = row.trim();
      var match = cleanRow.match(/^(.+?)(?:=>|=|:|：)(.+)$/);

      if (!match) return;

      var name = normalizeToken(match[1]);
      var sectionKeys = splitTargets(match[2]);

      if (!name || sectionKeys.length === 0) return;

      if (!sectionNameMap[name]) {
        sectionNameMap[name] = [];
      }

      sectionKeys.forEach(function (sectionKey) {
        if (sectionNameMap[name].indexOf(sectionKey) === -1) {
          sectionNameMap[name].push(sectionKey);
        }
      });
    });

    return sectionNameMap;
  }

  function findSectionByToken(token) {
    if (!token) return null;

    var cleanToken = token.replace(/^#/, '').replace(/^shopify-section-/, '');
    var directMatch = document.getElementById(token) || document.getElementById(cleanToken) || document.getElementById('shopify-section-' + cleanToken);

    if (directMatch) return directMatch;

    var sectionWrappers = document.querySelectorAll('[id^="shopify-section-"]');

    for (var index = 0; index < sectionWrappers.length; index += 1) {
      var wrapper = sectionWrappers[index];

      if (wrapper.id === token || wrapper.id === cleanToken || wrapper.id.endsWith('__' + cleanToken) || wrapper.id.endsWith(cleanToken)) {
        return wrapper;
      }
    }

    return null;
  }

  function uniqueElementsFromTargets(targets) {
    var elements = [];

    targets.forEach(function (target) {
      var element = findSectionByToken(target);

      if (element && elements.indexOf(element) === -1) {
        elements.push(element);
      }
    });

    return elements;
  }

  function CommunityPageTabs(root) {
    this.root = root;
    this.tabs = Array.prototype.slice.call(root.querySelectorAll('[data-community-page-tab]'));
    this.sectionNameMap = parseSectionNameMap(root.dataset.sectionNameMap);
  }

  CommunityPageTabs.prototype.init = function () {
    var activeTab = this.tabs.find(function (tab) {
      return tab.getAttribute('aria-selected') === 'true';
    }) || this.tabs[0];

    this.tabs.forEach(function (tab) {
      tab.addEventListener('click', this.onTabClick.bind(this, tab));
    }, this);

    if (activeTab) {
      this.activateTab(activeTab, false);
    }
  };

  CommunityPageTabs.prototype.onTabClick = function (tab, event) {
    var targets = splitTargets(tab.dataset.targetSections);

    if (targets.length === 0 && tab.tagName === 'A') {
      return;
    }

    event.preventDefault();
    this.activateTab(tab, true);
  };

  CommunityPageTabs.prototype.activateTab = function (activeTab, shouldScroll) {
    var activeTargets = this.resolveTargets(splitTargets(activeTab.dataset.targetSections));
    var activeIndex = activeTab.dataset.tabIndex || '0';

    this.root.style.setProperty('--community-page-tabs-active-index', activeIndex);

    this.tabs.forEach(function (tab) {
      var isActive = tab === activeTab;

      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');

      if (isActive) {
        tab.setAttribute('aria-current', 'page');
      } else {
        tab.removeAttribute('aria-current');
      }
    });

    this.updateControlledSections(activeTargets);

    if (shouldScroll) {
      this.scrollRootIntoViewIfNeeded();
    }
  };

  CommunityPageTabs.prototype.scrollRootIntoViewIfNeeded = function () {
    var root = this.root;

    // 等待 section 显隐引起的 reflow 完成后再判断，避免滚动过程中页面高度突变导致抖动
    requestAnimationFrame(function () {
      var rect = root.getBoundingClientRect();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

      // Tab 栏已在视口内可见时不再强制滚动，避免每次切换都跳动
      if (rect.bottom > 0 && rect.top < viewportHeight) {
        return;
      }

      var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      root.scrollIntoView({ block: 'start', behavior: prefersReducedMotion ? 'auto' : 'smooth' });
    });
  };

  CommunityPageTabs.prototype.getAllTargets = function () {
    var targets = [];

    this.tabs.forEach(function (tab) {
      this.resolveTargets(splitTargets(tab.dataset.targetSections)).forEach(function (target) {
        if (targets.indexOf(target) === -1) {
          targets.push(target);
        }
      });
    }, this);

    return targets;
  };

  CommunityPageTabs.prototype.resolveTargets = function (targets) {
    var resolvedTargets = [];

    targets.forEach(function (target) {
      var mappedTargets = this.sectionNameMap[normalizeToken(target)];
      var finalTargets = mappedTargets && mappedTargets.length > 0 ? mappedTargets : [target];

      finalTargets.forEach(function (finalTarget) {
        if (resolvedTargets.indexOf(finalTarget) === -1) {
          resolvedTargets.push(finalTarget);
        }
      });
    }, this);

    return resolvedTargets;
  };

  CommunityPageTabs.prototype.updateControlledSections = function (activeTargets) {
    var controlledElements = uniqueElementsFromTargets(this.getAllTargets());
    var activeElements = uniqueElementsFromTargets(activeTargets);

    controlledElements.forEach(function (element) {
      var shouldShow = activeElements.indexOf(element) !== -1;
      var wasHidden = element.classList.contains(hiddenClass);

      element.classList.add(panelClass);

      if (shouldShow) {
        element.hidden = false;
        element.classList.remove(hiddenClass);

        if (wasHidden) {
          element.classList.add(enterClass);

          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              element.classList.remove(enterClass);
            });
          });
        }

        // 刷新内部 Swiper/轮播组件：Swiper 若在隐藏容器中初始化会拿到 0 宽，导航锁定错乱
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            var swiperContainers = element.querySelectorAll('.swiper');
            for (var i = 0; i < swiperContainers.length; i++) {
              var swiperInstance = swiperContainers[i].swiper;
              if (swiperInstance && typeof swiperInstance.update === 'function') {
                swiperInstance.updateSize();
                swiperInstance.updateSlides();
                if (swiperInstance.navigation && typeof swiperInstance.navigation.update === 'function') {
                  swiperInstance.navigation.update();
                }
                swiperInstance.update();
              }
            }
          });
        });
      } else {
        element.hidden = true;
        element.classList.add(hiddenClass);
        element.classList.remove(enterClass);
      }
    });
  };

  function initCommunityPageTabs(scope) {
    var roots = Array.prototype.slice.call((scope || document).querySelectorAll('[data-community-page-tabs]'));

    roots.forEach(function (root) {
      if (initializedRoots.has(root)) return;

      initializedRoots.add(root);
      new CommunityPageTabs(root).init();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCommunityPageTabs(document);
    });
  } else {
    initCommunityPageTabs(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initCommunityPageTabs(event.target);
  });
})();